import React from 'react'

import { FreightListType } from '@application/Types/ComponentTypes'

import { FreightResourcesListItem } from './FreightResourcesListItem'
import { useGetFreightResourceCategoriesList } from './Hooks'

export const FreightResourcesList = ({ title, language }: FreightListType): JSX.Element => {
    const categories = useGetFreightResourceCategoriesList(language)

    return (
        <>
            {categories?.map((category) => (
                <FreightResourcesListItem title={title} category={category} key={category.title} />
            ))}
        </>
    )
}
